module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sms_balance":"SMS Unit Balance","sms_used":"SMS Units Used"},"es":{"sms_balance":"Saldo de la unidad de SMS","sms_used":"Unidades SMS utilizadas"},"fr":{"sms_balance":"Solde de l\u0027unité SMS","sms_used":"Unités SMS utilisées"},"sw":{"sms_balance":"Salio la Kitengo cha SMS","sms_used":"Vitengo vya SMS Vilivyotumika"}}')
  delete Component.options._Ctor
}
